import {toCurrencyNumber} from '@veasel/core/tools';

const monetary = (value, placeholder) => toCurrencyNumber(value, placeholder);

export default monetary;
